export default __webpack_public_path__ + "static/media/property_346.3578ab86.png";